import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { ComponentSharedModule } from '@components/component.shared.module';
import { UiDialogComponent } from '@components/ui-dialog/ui-dialog.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [
        CommonModule,
        ComponentSharedModule,
        TranslateModule,
        MatDialogModule,
        MatButtonModule,
    ],
    declarations: [
        UiDialogComponent,
    ],
    exports: [
        UiDialogComponent,
    ],
})
export class UiDialogModule { }
